import * as Moment from "moment";
import { extendMoment } from "moment-range";

const moment = extendMoment(Moment);

export const getDatesByStartAndEndDate = (start_date_time: any, end_date_time: any) => {
  const range = moment.range(start_date_time, end_date_time);

  return Array.from(range.by("days"));
};

export const isWithinDateRange = (start_time: string, end_time: string, target_time: string, format = "YYYY-MM-DD HH:mm") => {
  const targetTime = moment(target_time, format);

  const startTime = moment(start_time, format);
  const endTime = moment(end_time, format);

  return targetTime.isSameOrAfter(startTime) && targetTime.isSameOrBefore(endTime);
};

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));
